// These constants represented in what situation
// a registration page has been started in

export const DESKTOP_LANDING = 'RegistrationPageContexts.DESKTOP_LANDING'
export const MOBILE_LANDING = 'RegistrationPageContexts.MOBILE_LANDING'
export const AFTER_LANDING = 'RegistrationPageContexts.AFTER_LANDING'

export default {
    DESKTOP_LANDING,
    AFTER_LANDING,
    MOBILE_LANDING,
}
